import React from 'react';
import './PC.css';
import Stoll from '../../img/PC/Stoll.png'
import Abbas from '../../img/PC/Abbas.png'
import Belfort from '../../img/PC/Belfort.png'
import Hajian from '../../img/PC/Hajian.png'
import Arshad from '../../img/PC/Arshad.png'
import Batista from '../../img/PC/Batista.png'
import Bejarano from '../../img/PC/Bejarano.png'
import Slosarz from '../../img/PC/Slosarz.png'
import Lightfoot from '../../img/PC/Lightfoot.png'
import ReactTree from '../../img/PC/ReactTree.png'
import invertase from '../../img/PC/invertase.png'
import Ignite from '../../img/PC/Ignite.png'
import SFEIR from '../../img/PC/SFEIR.png'
import arcab from '../../img/PC/arcab.png'
import Nubank from '../../img/PC/Nubank.png'
import Perez from '../../img/PC/Perez.png'
import Fteam from '../../img/PC/Fteam.png'
import DevAngels from '../../img/PC/DevAngels London.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Stoll,
          name: 'Scott Stoll',
          position: 'Flutter Developer',
          tw: 'https://twitter.com/scottstoll2017',
          ln: 'https://www.linkedin.com/in/scott-stoll-59722915a/',
          logo: DevAngels,
        },
        {
          photo: Abbas,
          name: 'Sakina Abbas',
          position: 'Co-Founder & CEO',
          tw: 'https://twitter.com/sakin8tor',
          ln: 'https://pk.linkedin.com/in/sakina-abbas',
          github: 'https://github.com/sakina-abbas',
          logo: ReactTree,
        },
        {
          photo: Belfort,
          name: 'Pedro Belfort',
          position: 'Lead Software Engineer @ Nubank, Co-Founder @ Lutick',
          ln: 'https://www.linkedin.com/in/pedrobelfort/',
          logo: Nubank,
        },
        {
          photo: Hajian,
          name: 'Majid Hajian',
          position: 'Head of DevRel',
          tw: 'https://twitter.com/mhadaily',
          ln: 'https://www.linkedin.com/in/mhadaily/',
          logo: invertase,
        },
        {
          photo: Arshad,
          name: 'Waleed Arshad',
          position: 'Senior Flutter Developer',
          ln: 'https://www.linkedin.com/in/waleed006/',
          logo: Ignite,
        },
        {
          photo: Batista,
          name: 'Elaine Dias Batista',
          position: 'Team leader',
          tw: 'https://twitter.com/elainedbatista',
          ln: 'https://www.linkedin.com/in/elaine-dias-batista/',
          logo: SFEIR,
        },
        {
          photo: Bejarano,
          name: 'Argel Bejarano',
          position: 'Lead software engineer',
          tw: 'https://twitter.com/ArkangelB',
          logo: Nubank,
        },
        {
          photo: Slosarz,
          name: 'Rafał Ślósarz',
          position: 'VicePresident of Engineering at Arcab',
          ln: 'https://www.linkedin.com/in/rafal-slosarz/',
          logo: arcab,
        },
        {
          photo: Lightfoot,
          name: 'Simon Lightfoot',
          position: 'CTO',
          tw: 'https://twitter.com/devangelslondon',
          ln: 'https://www.linkedin.com/in/simonlightfoot/ ',
          github: 'https://github.com/slightfoot',
          logo: DevAngels,
        },
        {
          photo: Perez,
          name: 'Matheus Perez',
          position: 'Co-Ceo at Fteam and Co-founder Flutterando',
          tw: 'https://twitter.com/perezdev_',
          ln: 'https://www.linkedin.com/in/matheusperez/',
          inst: 'https://www.instagram.com/matheuslperez/',
          logo: Fteam,
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target="_blank" rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target="_blank" rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target="_blank" rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target="_blank" rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target="_blank" rel="noreferrer" href={item.website}></a>}
            {item.inst && <a className="pc_link social_inst" target="_blank" rel="noreferrer" href={item.inst}></a>}
          </div>
          <img className="pc_logo" src={item.logo} alt="" />
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc" id='pc'>
              <h3>Program committee</h3>
              <div className='container team_wrap'>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                  </div>
              </div>
          </div>
      )
  }
}